import Tone from 'tone';
import {getMilliseconds} from './getMilliseconds.js';
import {setEffectParameterValues} from 'actions/index.js';

const obj = (id, value) => {
    let b = {
    };
    b[id] = value;
    return b;
};

export default superclass => class extends superclass  {
    releaseAll(time) {
        this.getSamplers()
            .filter((sampler) => sampler !== undefined)
            .filter((sampler) => sampler.isLoaded())
            .map((sampler) => sampler.releaseAll(time));
    }

    liveTriggerRelease(transpose, sliceNumber) {
       if (!this.gated) {
            return;
        }
        this.triggerRelease(transpose, sliceNumber);
        this.chokes.liveRelease();
    }

    resetAnyPLockedParameters(stepData, time) {
        if (this.previousPLocks && this.previousPLocks.length > 0) {
            // if there are no plocks at this step, but we had a plock
            // on the last triggered step, then we need to go back
            // to the defaults for the instrument
            let _previous = Array.from(new Set(this.previousPLocks));
            let bulk = _previous
                .filter(p => p.savedUnlockedValue)
                .filter(p => !stepData || !stepData.pLockedParameters.includes(p))
                .map(
                p => {
                    if (p.savedUnlockedValue === undefined) {
                        return {id: -1, value: -1};
                    }
                    let r = p.set(p.savedUnlockedValue, true, true, time);
                    p.savedUnlockedValue = undefined;
                    return r;
                })
                .reduce((a, {id, value}) => ({... a, ...obj(id,value)}), {});
            this.store.dispatch(
                setEffectParameterValues(bulk));
        }
    }

    handlePLockedAutomations(stepData, time) {
        if (this.isMetronome) {
            return;
        }
        let steps = this.store.getState().keyboard.selectedPianoRollSteps;
        if (steps && steps.some(x => x.track === this)) {
            // if there are any selected steps on this track then
            // dont run the p-locks. This makes it so the interface
            // isn't jumping around while you try to set a new p-lock
            return;
        }
        this.resetAnyPLockedParameters(stepData, time);
        this.previousPLocks = stepData.triggerAutomations(time, this);
    }

    /*
    triggerAnimation(stepData, time) {
        let map = this.sequencerEngine.keyboardEngine.midiMappings;
        let pad = Object.keys(map)[0];
        if (!pad) {
            return;
        }
        for (let k in map[pad]) {
            let _map = map[pad][k];
            if (_map.trackNumber === this.trackNumber &&
                _map.sliceNumber === stepData.slice) {
                // then we want to light up that pad
                let output = 
                    this.sequencerEngine.midi.controllerOutputs.find(
                        x => x.name === pad);
                this.sequencerEngine.midi.playNote(
                    output,
                    undefined,
                    0,
                    getMilliseconds(time),
                    stepData.duration * new Tone.Time('16n').toMilliseconds(),
                    1,
                    1);
                return;
            }
        }
        
    }
    */

    // functions for triggering the underlying Samplers of the track
    trigger(stepData, time) {
        time = time || Tone.Master.context.currentTime;
        this.getSamplers()
            .filter((sampler) => sampler !== undefined)
            .filter((sampler) => sampler.isLoaded())
            .map((sampler) => {
                sampler.trigger({
                    gated: this.isWarped() ? true : this.isFrozen ? false : this.gated,
                    stepData: stepData,
                    time: time,
                    sliceNumber: stepData.slice
                });
            });
    }

    triggerSamples(stepData, time, velocity) {
        this.soundIds.filter(
            soundId => 
                this.isRecordingPlaying(soundId))
            .map(soundId =>
                 this.samplers[soundId])
            .filter((sampler) => sampler !== undefined)
            .filter((sampler) => sampler.isLoaded())
            .map((sampler) => sampler.trigger({
                gated: false,
                stepData: stepData,
                time: time
            }));
    }

    triggerSlice(slice) {
        let transpose = this.trackData.transpose;
        this.triggerSample(slice, transpose);
    }

    triggerSample(slice, transpose, skipRelease=false, velocity, time, noDuration, start, stepData) {
        this.getSamplers()
            .filter(sampler => sampler !== undefined)
            .filter(sampler => sampler.isLoaded())
            .forEach(sampler => sampler.trigger(
                {
                    gated: this.isWarped() ? true : this.gated,
                    sliceNumber: slice,
                    stepData: stepData || this.trackData,
                    start: start,
                    noDuration,
                    velocity,
                    transpose,
                    skipRelease,
                    time}));
    }

    triggerRelease(transpose, sliceNumber=0) {
        this.getSamplers().filter((sampler) => sampler.isLoaded())
            .forEach((sampler) => sampler.release(sliceNumber, transpose));
    }

    triggerMidiNoteOn(note, velocity) {
        this.triggerSample(
            0, // use sliceNumber 0 by default
            false,
            this.resolution.getTimeInStep(),
            note + this.trackData.transpose,
            true);
    }

    triggerMidiNoteOff(note) {
        // for sampler we dont directly do this here
    }

    liveTrigger(stepData=this.trackData, sliceNumber=0, time) {
        this.triggerSample(
            sliceNumber, // use sliceNumber 0 by default
            stepData.transpose,
            true,
            stepData.velocity,
            time,
            stepData.duration === undefined,
            stepData.start,
            stepData.track && stepData
        );

        this.chokes.liveTrigger();
    }


}
